<template>
  <v-dialog
    v-bind="$attrs"
    :model-value="modelValue"
    class="base-dialog-box"
    content-class="white base-dialog-box--modal"
    :width="width ?? 'auto'"
    overlay-color="var(--v-black-base)"
    overlay-opacity=".15"
    persistent
  >
    <slot />
  </v-dialog>
</template>

<script setup lang="ts">
import { VDialog } from 'vuetify/components'

defineProps<{ width?: string | number }>()
const modelValue = defineModel({ default: false })
</script>
